import { ref } from 'vue';

export const replyText = ref('');